import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "768",
  height: "239",
  viewBox: "0 0 768 239",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  preserveAspectRatio: "none"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g clip-path=\"url(#clip0_3_119)\"><mask id=\"mask0_3_119\" style=\"mask-type:alpha;\" maskUnits=\"userSpaceOnUse\" x=\"0\" y=\"-91\" width=\"768\" height=\"391\"><rect y=\"-91\" width=\"768\" height=\"391\" fill=\"#D9D9D9\"></rect></mask><g mask=\"url(#mask0_3_119)\"><path d=\"M817.218 215.043L737.844 -163.996L-47.2034 0.401548L-19.2276 133.995C79.9726 118.511 81.238 175.294 183.613 174.971C263.544 174.73 280.592 137.963 343.23 154.053C405.873 170.164 408.464 245.05 489.072 238.728C569.701 232.401 583.32 174.227 663.949 167.9C744.578 161.573 718.04 230.522 817.24 215.038\" fill=\"#4B291D\"></path><rect y=\"-1\" width=\"768\" height=\"61\" fill=\"#4B291D\"></rect></g></g><defs><clipPath id=\"clip0_3_119\"><rect width=\"768\" height=\"239\" fill=\"white\"></rect></clipPath></defs>", 2)
const _hoisted_4 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }